import React from 'react';
import { Global, css } from '@emotion/core';
import emotionReset from 'emotion-reset';
import emotionNormalize from 'emotion-normalize';
import fontFamilies from './fonts';
import { colorsPalette } from './colors';
import a11y from './a11y';

export const buttonReset = css({
  background: 'none',
  border: 'none',
  padding: 0,
  textDecoration: 'none',
});

export default () => (
  <Global
    styles={css`
    ${emotionReset}
    ${emotionNormalize}
    ${fontFamilies}

    html {
      box-sizing: border-box;
      font-family: 'effra', sans-serif;
      color: ${colorsPalette.black};
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    body {
      overflow-x: hidden;
    }

    *,
    *::before,
    *::after {
      box-sizing: inherit;
    }

    .lock-scroll {
      overflow: hidden;
      position: fixed;
      width: 100%;
    }
    
    html[dir=rtl] .icon-arrow-previous,
    html[dir=rtl] .icon-arrow-next,
    html[dir=rtl] .icon-arrow-right,
    html[dir=rtl] .icon-arrow-left,
    html[dir=rtl] .icon-chevron-right, 
    html[dir=rtl] .icon-chevron-left {
      transform: rotate(180deg);
    }

    ${a11y}
    `}
  />
);
